module.exports = __webpack_public_path__ + "img/button_play.4dbb4542.svg";